import React, { useEffect } from 'react';

import { GridOptions } from 'ag-grid-community';

import { buildActivityDrillInColumnDefV2 } from 'app/components/AdvancedGrid/GridHelpers/ActivityDrillIn/ActivityDrillInColumnDef';
import GridV2 from 'app/components/AdvancedGrid/GridV2';

import { TABLE_ROW_SIZE } from 'app/constants/DataPanelConstants';

import { useData } from 'app/contexts/dataProvider';
import { useLocalization } from 'app/contexts/localizationProvider';
import { useScope } from 'app/contexts/scopeProvider';

import { useGetActivitiesForFileLazy } from 'app/graphql/queries/getActivitiesForFile';

import useShowToast from 'app/hooks/useShowToast';

import block from 'utils/bem-css-modules';
import { buildRowDataFromFile } from 'utils/helpers/buildRowDataFromFile';
import { formatMessage } from 'utils/messages/utils';

import style from './PublishedTableDrillIn.module.pcss';

const b = block(style);

const PublishedTableDrillIn: React.FC = () => {
  const { defaultReportingCurrency } = useLocalization();
  const { selectedPlanningCycle } = useScope();
  const { selectedTable } = useData();
  const showToast = useShowToast();

  const [getActivities, { data: activities, loading: activitiesLoading }] = useGetActivitiesForFileLazy({
    variables: {
      planningCycleId: selectedPlanningCycle.id,
      fileId: selectedTable.tableId,
      startRow: 0,
      endRow: TABLE_ROW_SIZE
    },
    fetchPolicy: 'network-only',
    onError() {
      showToast(formatMessage('GET_ACTIVITIES_FOR_FILE_ERROR'), 'danger');
    }
  });

  const activityData = buildRowDataFromFile(activities?.getActivitiesForFile?.territoryActivitiesList);

  useEffect(() => {
    if (selectedTable && selectedPlanningCycle) {
      getActivities();
    }
  }, [selectedTable, selectedPlanningCycle]);

  const gridOptions: GridOptions = {
    rowData: activityData,
    loading: activitiesLoading,
    columnDefs: buildActivityDrillInColumnDefV2(
      activities?.getActivitiesForFile?.territoryActivitiesList || [],
      defaultReportingCurrency
    )
  };

  return (
    <div className={b('tableGridContainer')} data-testid="published-table-drill-in">
      <GridV2 data-testid="published-table-drill-in-grid" {...gridOptions} />
    </div>
  );
};

export default PublishedTableDrillIn;
